module.exports = __webpack_public_path__ + "static/img/csyxst-details.654cb6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/csyxst-details.png
// module id = zeUT
// module chunks = 0